export default {
  optionsCharacteristicsRisks: 'https://assets.tastyworks.com/production/documents/USA/characteristics_and_risks_of_standardized_options/versions/characteristics_and_risks_of_standardized_options-2.0.0.pdf',
};
